const SvgEditaProfesional: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={`h-8 w-8 p-0.5  ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="white"  // Asegura que el icono sea blanco
    stroke="currentColor"
    strokeWidth={1}

  >

    <path d="M21.662,10.678c-.276,.008-.493,.239-.485,.515,.011,.354,.017,.714,.017,1.083,0,.717-.023,1.448-.068,2.179-3.329,.316-5.777,1.017-5.881,1.047-.164,.048-.292,.176-.341,.34-.03,.103-.729,2.517-1.029,6.084-.716,.05-1.423,.076-2.105,.076-3.917,0-7.403-.831-8.375-1.084-.249-.948-1.048-4.337-1.048-8.641,0-4.262,.801-7.684,1.049-8.64,.973-.253,4.46-1.084,8.374-1.084l.476,.004c.298-.037,.503-.217,.508-.492,.004-.276-.216-.503-.492-.508l-.491-.004C7.035,1.551,3.019,2.698,2.85,2.747c-.164,.048-.292,.176-.341,.34-.047,.162-1.162,4.021-1.162,9.188,0,5.212,1.115,9.03,1.162,9.19,.048,.163,.177,.291,.34,.338,.168,.049,4.175,1.196,8.92,1.196,.844,0,1.723-.038,2.612-.111,.12-.01,.233-.063,.317-.15l7.256-7.476c.082-.084,.131-.195,.14-.312,.065-.895,.099-1.795,.099-2.676,0-.378-.006-.75-.017-1.113-.008-.276-.245-.47-.515-.485Zm-5.87,5.711c.631-.165,2.321-.572,4.489-.837l-5.313,5.474c.255-2.302,.66-4.006,.824-4.637Z" />
    <path d="M22.648,4.043c-.007-.05-.175-1.247-.994-2.067-.824-.8-2.031-.965-2.082-.972-.115-.015-.233,.01-.331,.073-.091,.057-2.266,1.448-6.762,5.887-4.737,4.677-5.985,6.512-6.037,6.588-.045,.067-.073,.145-.082,.225l-.331,3.098c-.016,.15,.037,.299,.143,.406,.094,.095,.222,.147,.354,.147,.017,0,.035,0,.052-.003l3.138-.328c.079-.008,.155-.035,.222-.079,.077-.05,1.935-1.283,6.671-5.96,4.497-4.439,5.905-6.588,5.963-6.677,.064-.1,.091-.22,.076-.338Zm-6.741,6.303c-4.061,4.01-5.992,5.462-6.422,5.77l-2.395,.25,.251-2.353c.315-.43,1.787-2.336,5.84-6.338,3.734-3.687,5.863-5.25,6.436-5.647,.297,.067,.911,.247,1.335,.659,.417,.418,.601,1.016,.669,1.311-.408,.573-1.991,2.673-5.714,6.348Z" />

  </svg>
);

export default SvgEditaProfesional;



